var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lined--title"},_vm._l((_vm.lines),function(row,index){return _c('div',{key:index,class:{ 'lined--title__row': true, unic: _vm.lines.length === 1 }},[_vm._v(" "+_vm._s(row)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }